/* global Videos */
const Team = function() {
    const STICKY_ELEMENTS_HEIGHT = 234;

    let VIDEOS_INITED = false;
    let block_load_more = false;
    let scrolledOnce = false;

    var update_filters = function(data, update_leagues) {
        var opt = '';
        if (update_leagues) {
            for (var ix in data['leagues']) {
                opt += '<option value="' + data['leagues'][ix][0] + '">' + data['leagues'][ix][1] + '</option>';
            }
            $('#league_selector').html(opt);
        }

        opt = '';
        for (var iy in data['seasons']) {
            opt += '<option value="' + data['seasons'][iy][0] + '">' + data['seasons'][iy][1] + '</option>';
        }
        $('#season_selector').html(opt);
    };

    let loadMoreMatches = (success_cb, always_cb = (_) => {}) => {
        let matches_container = $('#matches_container');
        let current_offset = parseInt(matches_container.data('current_offset'));
        Ajax.getTeamMatches(Team.team_id, current_offset, (res) => {
            if (res.success == 'ok') {
                matches_container.append(res.html);
                matches_container.data('current_offset', res.new_offset);
                Generic.init_popovers();
                success_cb(res);
            }
        }).finally((res) => {
            always_cb(res);
        });

    };

    let handleMoreClick = () => {
        $('#more_matches_btn').click(function() {
            Generic.showProgressLoader();
            loadMoreMatches(
                (res) => {
                    if (!res.show_more) {
                        $(this).hide(); // TODO Does this work?
                    }
                },
                (_) => {
                    Generic.hideProgressLoader();
                }
            );
        });
    };

    let handleScroll = () => {
        $(window).scroll(function() {
            if (window.scrollY >= STICKY_ELEMENTS_HEIGHT) {
                $('.intro--img').addClass('intro--img-on');
            } else {
                $('.intro--img').removeClass('intro--img-on');
            }


            if (!$('#summary_tab').hasClass('active')) {
                return;
            }
            // always skip the first scroll to avoid requests when the user reloads after scrolling
            if (!scrolledOnce) {
                scrolledOnce = true;
                return;
            }
            if (window.scrollY + 2000 < $(document).height() - $(window).height() || block_load_more) {
                return;
            }
            block_load_more = true;
            loadMoreMatches((res) => {
                if (res.show_more) {
                    window.setTimeout(() => {
                        // this needs to be in a timeout as we want to make sure that
                        // block_load_more flag is toggled after the DOM has been updated
                        // with the new matches rows (since $.append() in loadMoreMatches()
                        // triggers scroll events causing an infinite loop of scroll event triggers)
                        // You think $.append() is synchronous? You are right!
                        // but DOM rendering isn't. See more about this hack: https://stackoverflow.com/a/41893544/5710985
                        block_load_more = false;
                    }, 0);
                }
            });
        });
    };

    let videoModalOpen = () => {
        let hash = window.location.hash.substring(1); // hash w/o '#'
        return hash && !isNaN(hash);
    };

    return {
        initOverlay: function() {
            // TODO: this must be moved to a generic js (along with rendering for all mobile headers)
            if (Generic.mobile) {
                $('.ii__overlay_open').click(function() {
                    $('.page').addClass('overlay-on');
                });
                $('.ii__overlay_close').click(function() {
                    $('.page').removeClass('overlay-on');
                    $('.overlay__body iframe').each(function() {
                        let src = $(this).attr('src');
                        $(this).attr('src', '');
                        $(this).attr('src', src);
                    });
                });
            } else {
                $('#modal-header-info').on('hide.bs.modal', function() {
                    $('#modal-header-info iframe').each(function() {
                        let src = $(this).attr('src');
                        $(this).attr('src', '');
                        $(this).attr('src', src);
                    });
                });
            }
        },
        init: function(team_id) {
            Team.team_id = team_id;

            if (Generic.mobile) {
                handleScroll();
            } else {
                handleMoreClick();
            }

            Generic.toggle_button_init('ii__atoggle', 'ii__atoggler');
            Generic.toggle_button_init('ii__ftoggle', 'ii__ftoggler');

            $('.showmore_btn').click(function() {
                if (!$(this).data('toggletarget') || $('.' + $(this).data('toggletarget')).length == 0) {
                    return;
                }
                $('.' + $(this).data('toggletarget')).show();
                $(this).hide();
            });

            $('#applyfilters').on('click', function(e) {
                window.location.replace(
                    window.location.href
                        .replace(window.location.hash, '')
                        .split('?')[0] +
                            '?l=' + $('#league_selector option:selected').val() +
                            '&s=' + $('#season_selector').val() +
                            '&a=' + $('#arrangement_selector').val() +
                            window.location.hash
                );
            });

            $('#league_selector').on('change', function() {
                Ajax.getTeamFiltersData(Team.team_id, this.value, function(data) {
                    update_filters(data, false);
                });
            });

            Team.initOverlay();

            let first_load_hash = window.location.hash.substring(1); // hash w/o '#'

            $('.ii__tab_nav').on('shown.bs.tab', function() {
                let href = $(this).attr('href');
                if (!videoModalOpen()) {
                    Generic.change_hash_without_scroll(href);
                }

                // Videos.init() must be called only once and only when the videos carousels are visible
                // (otherwise slick() can't calculate correctly the carousel dimensions)
                if (href == '#videos' && !VIDEOS_INITED) {
                    Videos.init(href);
                    VIDEOS_INITED = true;
                }
            });

            if (first_load_hash) {
                if (!videoModalOpen()) {
                    $(`.ii__tab_nav[href="#${first_load_hash}"]`).tab('show');
                } else {
                    $('#videos_tab').tab('show');
                }
            }
        }
    };
}();
